define('modules/profiles/main/views/profile.nav.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    'modules/base/views/model.view',
    'text!modules/profiles/main/templates/profile.nav.template.html'
], function (Prospector, $, _, Backbone, Marionette, BaseView, Template) {
    var ProfileHeaderView = BaseView.extend({
        template: _.template(Template),
        className: 'p-nav',
        tagName: 'div',
        initialize: function(options){
            this.parent = options.parent;
            this.model = options.model;
            this.firstLoad = true;
            BaseView.prototype.initialize.call(this, options);
        },
        mEvents:function(){
            return {
                'click .menuPop':'menuPopup',
                //'click .list':'sendToProfileBoard',
                'click .logo': 'sendToSearch',
                'click .relpro-sk-search': 'sendToSearch'
            };
        },
        onRender: function(){

        },
        buildModel: function(){

        },
        // sendToProfileBoard: function(e){
        //     Prospector.trigger("menuClicked", e);
        // },
        menuPopup: function(){
            if(window.location.href.indexOf("person") > -1){ // If current profile page is of a person
                $('.popMenu').toggle('slide');
            }

            if(window.location.href.indexOf("organization") > -1){// If current profile page is of a Organization
                $('.popMenu2').toggle('slide');
            }
        },
        sendToSearch: function(){
            Prospector.trigger('dashboard', true);
        }

    });

    return ProfileHeaderView;

});
